export function readAccessTokenCookie(): string {
  if (typeof document === 'undefined') return '';
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const [rawName, ...rawValueParts] = part.trim().split('=');
    if (
      rawName === 'accounts%3AaccessToken' ||
      rawName === 'accounts:accessToken'
    ) {
      const rawValue = rawValueParts.join('=');
      try {
        return decodeURIComponent(rawValue || '').trim();
      } catch {
        return (rawValue || '').trim();
      }
    }
  }
  return '';
}
